<app-dialog
  [isVisible]="isDialogVisible"
  dialogHeader=" "
  [settings]="{
    showCustomFooter: false,
    showCustomHeader: false,

    closeOnEscape: true,
    isDraggable: ['draggable', 'all'].includes(dialogType),
    isResizable: true,
    isMaximizable: ['maximizable', 'all'].includes(dialogType),
    width: '95vw',
    maxWidth: dialogType === 'simple' ? '290px' : '',
    useCustomCloseIcon: true,
  }"
  [emitOnHide]="true"
  (dialogHide)="handleDialogClose()"
>
  <div dialog-body>
    <div
      class="section-container flex flex-column gap-spacing-3xl table-bg-hover-bg radius-lg justify-content-center align-content-center align-items-center"
    >
      <div class="flex flex-column gap-spacing-md">
        <div class="flex justify-content-center">
          <img src="/assets/icons/logo-vertical-about.svg" alt="google" />
        </div>
        <span class="body-small-regular text-light-color">Version 3.0</span>
      </div>

      <div
        class="details-container flex flex-column justify-content-center align-items-center gap-spacing-xs"
      >
        <div class="flex flex-column justify-content-center align-items-center">
          <span class="fixed-text text-light-color body-small-regular"
            >For any support- related questions, please reach out to us
            at:</span
          >
          <div class="border-neutral-base-seperator-color label-large-medium">
            <a href="mailto:cesupport@gobeacon.com" class="no-underline">
              <span class="text-link-color body-small-medium cursor-pointer"
                >cesupport&#64;gobeacon.com
              </span>
            </a>
          </div>
        </div>

        <span class="fixed-text text-light-color body-small-regular"
          >©{{ currentYear() }} Adroit Advanced Technologies Inc, a Beacon's
          company. All rights reserved.</span
        >
      </div>

      <app-button
        label="Close"
        sizeClass="p-button-sm"
        severity="primary"
        (btnClick)="handleDialogClose()"
        [outlinedButton]="true"
      ></app-button>
    </div>
  </div>

  <div dialog-footer>
    <div>
      <app-button
        label="Close"
        sizeClass="p-button-md"
        severity="secondary"
        (btnClick)="handleDialogClose()"
        [outlinedButton]="true"
      ></app-button>
    </div></div
></app-dialog>
